import type { TModernColors } from '@modern/theme/modern-theme.types';

// No prototype light theme exists; built to the dark palette's roles and floors.
export const lightColors: TModernColors = {
  accent: {
    base: '#d01a4c',
    border: 'rgba(208, 26, 76, 0.36)',
    deep: '#c51e42',
    deepHover: '#ad1a3a',
    hover: '#a8143c',
    tint: 'rgba(208, 26, 76, 0.08)',
    tintStrong: 'rgba(208, 26, 76, 0.13)',
  },
  border: {
    hairline: 'rgba(16, 24, 40, 0.12)',
    strong: 'rgba(16, 24, 40, 0.5)',
    subtle: 'rgba(16, 24, 40, 0.2)',
  },
  chart: {
    series: [
      '#2f6fc4',
      '#c24f1f',
      '#13805a',
      '#9c6a00',
      '#6b5fd3',
      '#be3f6e',
      '#0b760b',
      '#c94545',
    ],
  },
  overlay: {
    hover: 'rgba(16, 24, 40, 0.06)',
    hoverStrong: 'rgba(16, 24, 40, 0.09)',
    hoverSubtle: 'rgba(16, 24, 40, 0.035)',
    scrim: 'rgba(16, 24, 40, 0.42)',
    selected: 'rgba(16, 24, 40, 0.075)',
  },
  scrollbar: {
    thumb: '#c4c9d2',
    thumbHover: '#a7aebb',
  },
  status: {
    error: {
      base: '#c42a32',
      border: 'rgba(196, 42, 50, 0.4)',
      deep: '#b5232a',
      deepHover: '#9f1f25',
      tint: 'rgba(196, 42, 50, 0.08)',
      tintStrong: 'rgba(196, 42, 50, 0.12)',
    },
    neutral: {
      base: '#687284',
      border: 'rgba(16, 24, 40, 0.22)',
      tint: 'rgba(16, 24, 40, 0.05)',
      tintStrong: 'rgba(16, 24, 40, 0.08)',
    },
    ok: {
      base: '#1b7f49',
      border: 'rgba(27, 127, 73, 0.4)',
      tint: 'rgba(27, 127, 73, 0.08)',
      tintStrong: 'rgba(27, 127, 73, 0.12)',
    },
    sync: {
      base: '#2563c9',
      border: 'rgba(37, 99, 201, 0.38)',
      tint: 'rgba(37, 99, 201, 0.08)',
      tintStrong: 'rgba(37, 99, 201, 0.12)',
    },
    warning: {
      base: '#94600a',
      border: 'rgba(148, 96, 10, 0.42)',
      tint: 'rgba(196, 136, 20, 0.1)',
      tintStrong: 'rgba(196, 136, 20, 0.15)',
    },
  },
  surface: {
    base: '#ffffff',
    canvas: '#eef0f4',
    elevated: '#ffffff',
    raised: '#f6f7f9',
    track: '#d9dde5',
  },
  text: {
    onAccent: '#ffffff',
    primary: '#151a23',
    secondary: '#323947',
    tertiary: '#4b5363',
  },
};
